import { render, staticRenderFns } from "./PassLayout.vue?vue&type=template&id=9b04af4a&scoped=true&"
import script from "./PassLayout.vue?vue&type=script&lang=js&"
export * from "./PassLayout.vue?vue&type=script&lang=js&"
import style0 from "./PassLayout.vue?vue&type=style&index=0&id=9b04af4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b04af4a",
  null
  
)

export default component.exports